import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const TabContent = forwardRef(
  (
    {
      children,
      hidden = false,
      noSideSpacing = false,
      noVerticalSpacing = false,
      noOverflow = false,
    },
    ref
  ) => {
    const classes = classNames('ws-ui-tab-content', {
      'ws-ui-tab-content--hidden': hidden,
      'ws-ui-tab-content--no-side-spacing': noSideSpacing,
      'ws-ui-tab-content--no-vertical-spacing': noVerticalSpacing,
      'ws-ui-tab-content--no-overflow': noOverflow,
    });

    return (
      <div className={classes} ref={ref}>
        {children}
      </div>
    );
  }
);

TabContent.displayName = 'TabContent';

TabContent.propTypes = {
  children: PropTypes.node.isRequired,
  hidden: PropTypes.bool,
  noSideSpacing: PropTypes.bool,
  noVerticalSpacing: PropTypes.bool,
  noOverflow: PropTypes.bool,
};

export default TabContent;
